import { Fragment, useEffect } from "react";
import { Card, Col, Container, Row } from "reactstrap";
import { useAppDispatch } from "../../../../ReduxToolkit/Hooks";
import { fetchChatApiData, fetchChatMemberApiData } from "../../../../ReduxToolkit/Reducers/ChatSlice";
import { Breadcrumbs } from "../../../../AbstractElements";
import { Chats, GroupChat } from "../../../../Constants/Constants";
import RightGroupChatHeader from "./RightGroupChatHeader";
import RightChatBody from "../PrivateChat/UserChat/RightChatBody";
import LeftSideBar from "../PrivateChat/LeftSideBar/LeftSideBar";

const GroupChatContainer = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchChatMemberApiData());
    dispatch(fetchChatApiData());
  }, [dispatch]);

  return (
    <Fragment>
      <Breadcrumbs mainTitle={GroupChat} parent={Chats} />
      <Container fluid>
        <Row className="g-0">
          <LeftSideBar />
          <Col xxl="9" xl="8" md="7" className="box-col-7">
            <Card className="right-sidebar-chat">
              <RightGroupChatHeader />
              <RightChatBody />
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default GroupChatContainer;
